import { i as o } from "./is-callable.js";
import { i as r } from "./is-object.js";
import { o as t } from "./object-set-prototype-of.js";
var e = function e(_e, i, s) {
  var p, a;
  return t && o(p = i.constructor) && p !== s && r(a = p.prototype) && a !== s.prototype && t(_e, a), _e;
};
export { e as i };